var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12343809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1675844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1675843"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 12.2758,
    y: 3.23389,
    width: 0.75218,
    height: 12.7871,
    rx: 0.37609,
    transform: "rotate(45 12.2758 3.23389)",
    fill: "#9A9A9A",
    stroke: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 12.8076,
    y: 12.2759,
    width: 0.75218,
    height: 12.7871,
    rx: 0.37609,
    transform: "rotate(135 12.8076 12.2759)",
    fill: "#9A9A9A",
    stroke: "#9A9A9A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.557d507c933e61bd1b8f01f11366bdd1.svg";
export { ForwardRef as ReactComponent };